'use client'

import { ACCOUNT_DRAWER_HANDLE } from '@/feature/account/services/account.constants'
import { useSiteConfig } from '@/feature/config/hooks/useSiteConfig.client'
import { toQuickOrder } from '@/feature/quick-order/services/quick-order.routing'
import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { useNextIsClientHydrated } from '@/lib/next/useNextIsClientHydrated'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { useCloseDrawer } from '@/ui/drawer/drawer/Drawer.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { NavigationCard } from '@/ui/cards/navigation-card/NavigationCard.client'
import { useQuery } from '@apollo/client'
import { gql } from '@gql-generated/gql'
import { NavigationHubQuickOrderDocument } from '@gql-generated/graphql'

gql(/* GraphQL */ `
  query NavigationHubQuickOrder($isQuoteEnabled: Boolean!) {
    currentUser {
      id
      permissions {
        canManageQuote @include(if: $isQuoteEnabled)
      }
    }
    config {
      sales {
        isQuickOrderEnabled
      }
      quotation {
        isQuotationEnabled
      }
    }
  }
`)

export function NavigationHubQuickOrderTile() {
  const { t } = useTranslation(['accountDrawer'])
  const closeAccountDrawer = useCloseDrawer(ACCOUNT_DRAWER_HANDLE)
  const isHydrated = useNextIsClientHydrated()
  const { config: siteConfig, loading: configLoading } = useSiteConfig()
  const isQuoteEnabled = !!siteConfig?.quotation?.isQuotationEnabled

  const { data } = useQuery(NavigationHubQuickOrderDocument, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    variables: { isQuoteEnabled },
    skip: !isHydrated || configLoading || APOLLO_CLIENT_SIDE_OPTIONS.skip,
  })

  const isQuotationEnabled = !!data?.config?.quotation?.isQuotationEnabled
  const canManageQuote = !!data?.currentUser?.permissions?.canManageQuote
  const canDisplayQuotes = isQuotationEnabled && canManageQuote
  const isQuickOrderEnabled = !!data?.config?.sales?.isQuickOrderEnabled

  if (canDisplayQuotes || !isQuickOrderEnabled) return null

  return (
    <NavigationCard
      className="grow basis-[calc(50%_-_0.25rem)]"
      href={toQuickOrder}
      icon={<Icon.FastForward />}
      size="lg"
      onPress={() => {
        closeAccountDrawer()
        pushToGtmDataLayer({
          event: 'gaEvent',
          eventCategory: 'layer mon compte',
          eventAction: 'clic section',
          eventLabel: 'commande rapide',
        })
      }}
    >
      {t('accountDrawer:quickOrder')}
    </NavigationCard>
  )
}
